import Observable, { type Observer } from '@utils/observable';
import { publicClient } from '.';

const events = new Observable();

const addListener = (listener: Observer) => {
	events.subscribe(listener);

	return () => {
		events.unsubscribe(listener);
	};
};

function getOauthAuthorization() {
	// const clientId = '';
	// const clientSecret = '';
	// return (clientId !== undefined && clientSecret !== undefined) ? `Basic ${window.btoa(`${clientId}:${clientSecret}`)}` : '';
	return 'Basic ZXN0YWdpbDplc3RhZ2lsLWJldGE=';
}

async function login(username: string, password: string): Promise<any> {
	const headers = {
		'Content-Type': 'application/x-www-form-urlencoded',
		Accept: 'application/json',
		Authorization: getOauthAuthorization(),
	};

	const params = {
		method: 'POST',
		body: `grant_type=password&username=${username}&password=${password}`,
	};

	try {
		const res = await publicClient({
			url: 'https://hyueftwmci.us16.qoddiapp.com/oauth/token',
			headers,
			params,
		});
		return persistTokens(res);
	} catch (e) {
		logout();
	}
}

function logout() {
	persistTokens({ access_token: '', refresh_token: '', expires_in: 0 });
}

async function refresh() {
	const token = refreshToken();

	const headers = {
		'Content-Type': 'application/x-www-form-urlencoded',
		Accept: 'application/json',
		Authorization: getOauthAuthorization(),
	};

	const params = {
		method: 'POST',
		body: `grant_type=refresh_token&refresh_token=${token}`,
	};

	try {
		const res = await publicClient({
			url: 'https://hyueftwmci.us16.qoddiapp.com/oauth/token',
			headers,
			params,
		});
		return persistTokens(res);
	} catch (e) {
		logout();
	}
}

function persistTokens(res: any) {
	const expires = new Date();

	expires.setTime(expires.getTime() + (res.expires_in * 1000));
	document.cookie = `access_token=${res.access_token}; expires=${expires.toUTCString()};`;

	expires.setTime(expires.getTime() + (res.expires_in * 2000));
	document.cookie = `refresh_token=${res.refresh_token}; expires=${expires.toUTCString()};`;

	events.notify({
		access_token: accessToken(),
		refresh_token: refreshToken(),
		accessTokenAtivo: accessTokenAtivo(),
		refreshTokenAtivo: refreshTokenAtivo(),
	});

	return res;
}

function accessTokenAtivo() {
	return !!accessToken();
}

function refreshTokenAtivo() { return !!refreshToken(); }

function accessToken() {
	return getCookie('access_token');
}

function refreshToken() {
	return getCookie('refresh_token');
}

function getCookie(cookieName: string): string | undefined {
	const { cookie } = document;

	return cookie.split(';').find((c) => {
		const values = c.split('=');
		return values[0].trim() === cookieName.trim();
	})?.split('=')?.[1];
}

const auth = {
	login,
	logout,
	refresh,
	accessToken,
	accessTokenAtivo,
	refreshToken,
	refreshTokenAtivo,
	addListener,
};

export default auth;
